import { useTranslation } from "react-i18next";

const ctaBg =
  "https://readdy.ai/api/search-image?query=Modern%20luxury%20steel%20frame%20house%20at%20golden%20hour%20sunset%2C%20warm%20ambient%20lighting%20through%20floor-to-ceiling%20windows%2C%20contemporary%20architectural%20design%20with%20clean%20geometric%20lines%2C%20landscaped%20garden%20foreground%2C%20high-end%20residential%20photography%2C%20editorial%20quality%2C%20warm%20tones&width=1600&height=700&seq=2&orientation=landscape";

export default function FinalCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={ctaBg} alt="現代鋼構住宅黃金時段美景" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-r from-graphite/85 via-graphite/70 to-graphite/85" />
      </div>

      <div className="relative z-10 section-padding">
        <div className="container-main text-center max-w-3xl mx-auto">
          <span className="tag-label mb-6 inline-block">{t("seminars.final.label")}</span>
          <h2 className="text-white mb-8">{t("seminars.final.title")}</h2>
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary gap-2 inline-flex"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            {t("seminars.final.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}